import React, {useContext} from 'react'
import './Pricing.scss';
import AuthContext from "../../Store/auth-context";
import PriceGroup from "./PriceGroup";

function Pricing() {
    const {priceId,isLoggedIn} = useContext(AuthContext);
    return (
        <div id="pricing">
            <div className="row">
                <div className="col-lg order-lg-2">
                    <h1 className="headerText">Budget friendly plans designed to meet the needs of all financial scenarios and life situations.</h1>
                    <p>We understand that not everyone has a million dollars to spend. The truth is neither do we. Through this exact transparency and clarity we developed pricing plans that allow us to operate and also leave room for lots of money to be made by you. The end goal is to see our customers win. Through consistency and dedication every plan aims to offer this.</p>
                    <p>We will not win everything, however, that is the goal everytime our experts update the dashboard with their best picks. When exploring the different plans, pay for what makes sense for you. If you are comfortable with the world of handicapping, the yearly plan may give you the best bang for your buck. If you are new to it and true to it, start small! Whether you are a 1 day customer, or a monthly customer, we will be here for you no matter what.</p>
                </div>

                <div className="col-lg order-lg-1">
                    {
                        priceId.map((item, index)=>(
                         <PriceGroup key={item.id} price={item} idx={index} isLoggedIn={isLoggedIn}/>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default Pricing
